import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { __decorate } from "tslib";
import { ExamQuizPlayerStep, QuizResultState } from "@/models/quiz.model";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import { Component, Prop, Ref, Vue } from "vue-facing-decorator";
import QuizViewerLayout from "@/components/layout/QuizViewerLayout.vue";
import QuizViewerCarousel from "@/components/quiz/QuizViewerCarousel.vue";
import QuizPreamble from "@/components/quiz/QuizPreamble.vue";
import InformationDialog from "@/components/dialogs/NotificationDialog.vue";
import SimpleQuiz from "@/components/quiz/SimpleQuiz.vue";
import ChapterWideScreenMsg from "@/components/chapter/ChapterWideScreenMsg.vue";
import { isEqual, shuffle } from 'lodash';
import Timer from "@/components/quiz/Timer.vue";
import ExamQuizQuiz from "@/components/quiz/ExamQuiz.vue";
import ExamQuiz from "@/components/quiz/ExamQuiz.vue";
import ExamQuizScore from "@/components/quiz/ExamQuizScore.vue";
import ExamQuizResults from "@/components/quiz/ExamQuizResults.vue";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import axios from "axios";
import { Events } from "@/events/events";
let ExamQuizPlayer = class ExamQuizPlayer extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "quizJsonString", void 0);
    _defineProperty(this, "quizResultJsonString", void 0);
    _defineProperty(this, "chapterTitle", void 0);
    _defineProperty(this, "isScorm", void 0);
    _defineProperty(this, "canEdit", void 0);
    _defineProperty(this, "isSpeachTemplate", void 0);
    _defineProperty(this, "quizResultState", void 0);
    _defineProperty(this, "remainingTries", void 0);
    _defineProperty(this, "timer", void 0);
    _defineProperty(this, "remainingSeconds", void 0);
    _defineProperty(this, "hideValidationOnUnlimitedRetries", void 0);
    _defineProperty(this, "examQuizViewerCarousel", void 0);
    _defineProperty(this, "timerComponent", void 0);
    _defineProperty(this, "ExamQuizPlayerStep", ExamQuizPlayerStep);
    _defineProperty(this, "quiz", void 0);
    _defineProperty(this, "displayableQuestions", []);
    _defineProperty(this, "examQuizStep", ExamQuizPlayerStep.PREAMBLE);
    _defineProperty(this, "layoutKey", 0);
    _defineProperty(this, "isSavingResults", false);
    _defineProperty(this, "examQuizUserRealtimeData", {
      successRate: 0,
      remaningTries: 0,
      overallAnswers: null,
      currentQuestionRealtimeAnswers: null,
      timeElapsed: false,
      currentSlideIndex: 0
    });
    _defineProperty(this, "BASE_API_QUIZ", '/api/v2/quiz');
  }
  mounted() {
    if (this.quizJsonString) {
      this.quiz = JSON.parse(this.quizJsonString);
      this.buildDisplayableQuestions();
      this.buildExamQuizUserRealtimeData();
    }
  }
  get preambleItems() {
    const preambleItems = [this.$t('view.speach.examQuiz.start.nbQuestions', {
      nbQuestions: this.displayableQuestions.length
    }), this.timer ? this.$t('view.speach.examQuiz.start.timeLimit', {
      minutes: this.timer
    }) : this.$t('view.speach.examQuiz.start.timeNoLimit')];
    if (this.remainingTries === -1) {
      preambleItems.push(this.$t('view.speach.examQuiz.start.noLimitTries'));
    } else if (this.examQuizUserRealtimeData.remaningTries > 0) {
      const triesLabel = this.$t('view.speach.examQuiz.start.triesLabel', {
        count: this.examQuizUserRealtimeData.remaningTries
      });
      preambleItems.push(this.$t('view.speach.examQuiz.start.nbTry', {
        nbTry: this.examQuizUserRealtimeData.remaningTries,
        triesLabel: triesLabel
      }));
    }
    return preambleItems;
  }
  get userHasAnswered() {
    if (this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers?.responsesIds?.length) {
      return true;
    }
    if (this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers?.blanksResponses?.length) {
      return this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers?.blanksResponses?.every(blank => blank.textResponse?.trim()?.length || blank.responseOptionId);
    }
    if (this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers?.pairsMatching?.length) {
      return this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers.pairsMatching.every(pm => !!pm.responseRelatedItemId);
    }
    if (this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers?.itemsSorting?.length) {
      return true;
    }
    return false;
  }
  onSlideChange(eventData) {
    this.examQuizUserRealtimeData.currentSlideIndex = eventData.currentSlideIndex;
  }
  buildDisplayableQuestions() {
    if (this.quiz) {
      if (!this.quiz.randomMode) {
        this.displayableQuestions = this.quiz.questions || [];
      } else {
        const questions = shuffle((this.quiz?.questions || []).slice(0, this.quiz.nbChosenQuestions));
        questions.forEach((question, index) => question.order = index + 1);
        this.displayableQuestions = questions;
      }
    }
  }
  buildExamQuizUserRealtimeData() {
    this.initExamQuizUserRealtimeData(this.remainingTries);
    if (this.quizResultJsonString) {
      this.examQuizUserRealtimeData.overallAnswers = JSON.parse(this.quizResultJsonString);
      const savedResults = this.examQuizUserRealtimeData.overallAnswers;
      if (savedResults) {
        this.examQuizUserRealtimeData.successRate = savedResults.percentage || 0;
      }
      if (this.quizResultState === QuizResultState.QUIZZ_A_VALIDER) {
        this.examQuizStep = ExamQuizPlayerStep.COMPLETED;
        // Notify legacy PlanPanel to refresh pastille/button when results are already available
        try {
          trig(Events.QUIZZ_COMPLETED);
        } catch (e) {/* noop */}
      } else if (this.quizResultState === QuizResultState.QUIZZ_TERMINE) {
        this.examQuizStep = ExamQuizPlayerStep.TERMINATED;
        // Notify legacy PlanPanel to refresh pastille/button when quiz is already terminated
        try {
          trig(Events.QUIZZ_COMPLETED);
        } catch (e) {/* noop */}
      }
    }
  }
  get shouldDisplayRestartButton() {
    return !this.isScorm && this.examQuizStep === ExamQuizPlayerStep.COMPLETED && this.examQuizUserRealtimeData.successRate !== 100 && (this.examQuizUserRealtimeData.remaningTries === -1 || this.examQuizUserRealtimeData.remaningTries > 0);
  }
  get shouldDisplayTerminateButton() {
    return this.examQuizStep === ExamQuizPlayerStep.COMPLETED && this.userHasWinningRate && !(this.hideValidationOnUnlimitedRetries && this.remainingTries === -1);
  }
  get userHasWinningRate() {
    return this.examQuizUserRealtimeData.successRate >= (this.quiz?.scoreToContinue || 0);
  }
  onQuizAnswerChange(userAnswers) {
    this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers = userAnswers;
  }
  initExamQuizUserRealtimeData(remainingTries) {
    this.examQuizUserRealtimeData = {
      successRate: 0,
      remaningTries: this.remainingTries !== -1 ? remainingTries : this.remainingTries,
      overallAnswers: this.initRealtimeUserAnswers(this.quiz),
      currentQuestionRealtimeAnswers: null,
      currentSlideIndex: 0,
      timeElapsed: false
    };
  }
  initRealtimeUserAnswers(quiz) {
    if (!quiz) {
      return null;
    }
    return {
      contenuQuizId: quiz.id,
      questions: this.displayableQuestions.map(question => ({
        questionId: question.id,
        questionType: question.type,
        order: question.order,
        blanksText: question.blanksText,
        responsesIds: [],
        responseContent: '',
        blanksResponses: [],
        pairsMatching: [],
        itemsSorting: []
      })) || []
    };
  }
  onNextButtonClick() {
    switch (this.examQuizUserRealtimeData.currentSlideIndex) {
      case 0:
        this.examQuizStep = ExamQuizPlayerStep.STARTED;
        if (this.timer) {
          this.timerComponent.startCounting();
        }
        this.moveToNextSlide();
        trig(Events.STAT_START);
        break;
      default:
        this.updateOverallAnswersWithCurrentQuestionAnswers();
        if (this.lastSlideReached()) {
          if (this.timer && this.timerComponent.getRemainingSeconds() > 0) {
            this.timerComponent.stopCounting();
          }
          if (this.isScorm) {
            this.validateScormQuiz();
          } else {
            this.validateQuizAnswers();
          }
        } else {
          this.moveToNextSlide();
          this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers = null;
        }
        break;
    }
  }
  validateScormQuiz() {
    this.examQuizUserRealtimeData.successRate = this.computeSuccessRateForScorm();
    this.examQuizStep = ExamQuizPlayerStep.COMPLETED;
    console.log('Trig attempt to save scorm score..');
    trig(Events.SAVE_EXAM_QUIZ_SCORM_SCORE, this.examQuizUserRealtimeData.successRate);
    // Inform legacy PlanPanel that quiz flow reached completion step (COMPLETED)
    try {
      trig(Events.QUIZZ_COMPLETED);
    } catch (e) {/* noop */}
  }
  updateOverallAnswersWithCurrentQuestionAnswers() {
    this.examQuizUserRealtimeData.overallAnswers?.questions?.forEach(question => {
      if (question.questionId === this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers?.questionId) {
        question.responsesIds = this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers.responsesIds;
        question.blanksResponses = this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers.blanksResponses;
        question.pairsMatching = this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers.pairsMatching;
        question.itemsSorting = this.examQuizUserRealtimeData.currentQuestionRealtimeAnswers.itemsSorting;
      }
    });
  }
  async checkUserAnswersAndDisplayResults() {
    await axios.put(`${this.BASE_API_QUIZ}/${this.quiz?.id}/compute-exam-quiz-results-score`, {
      userAnswersJson: JSON.stringify(this.examQuizUserRealtimeData.overallAnswers)
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.examQuizUserRealtimeData.successRate = response.data;
      this.examQuizStep = this.examQuizUserRealtimeData.successRate === 100 ? ExamQuizPlayerStep.TERMINATED : ExamQuizPlayerStep.COMPLETED;
      // Notify legacy PlanPanel to refresh UI according to completion
      try {
        trig(Events.QUIZZ_COMPLETED);
      } catch (e) {/* noop */}
    }).catch(() => WElMessage.showErrorMessage(this.$t('errors.default'))).finally(() => this.isSavingResults = false);
  }
  async saveUserAnswersAndDisplayResults() {
    try {
      const savedResults = await this.saveUserAnswers();
      this.examQuizUserRealtimeData.successRate = savedResults.percentage;
      if (!this.canEdit && this.examQuizUserRealtimeData.remaningTries > 0) {
        this.examQuizUserRealtimeData.remaningTries--;
      }
      this.examQuizStep = this.examQuizUserRealtimeData.remaningTries === 0 || this.examQuizUserRealtimeData.successRate === 100 ? ExamQuizPlayerStep.TERMINATED : ExamQuizPlayerStep.COMPLETED;
      // Notify legacy PlanPanel to refresh pastille/button right after saving answers
      try {
        trig(Events.QUIZZ_COMPLETED);
      } catch (e) {/* noop */}
      this.isSavingResults = false;
    } catch (e) {
      WElMessage.showErrorMessage(this.$t('errors.default'));
      this.isSavingResults = false;
    }
  }
  async saveUserAnswers() {
    try {
      const response = await axios.put(`${this.BASE_API_QUIZ}/${this.quiz?.id}/exam-quiz-answers`, {
        userAnswersJson: JSON.stringify(this.examQuizUserRealtimeData.overallAnswers)
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  computeSuccessRateForScorm() {
    let nbBonneReponses = 0;
    this.examQuizUserRealtimeData.overallAnswers?.questions?.forEach(question => {
      const sourceQuestion = this.quiz?.questions?.find(q => q.id === question.questionId);
      if (sourceQuestion) {
        const goodAnswersIds = sourceQuestion?.answers?.filter(answer => answer.rightAnswer).map(answer => answer.id) || [];
        if (goodAnswersIds?.length && isEqual((question.responsesIds || []).sort(), goodAnswersIds.sort())) {
          nbBonneReponses++;
        }
      }
    });
    return Math.round(nbBonneReponses * 100 / this.displayableQuestions.length);
  }
  async onRestartButtonClick() {
    if (this.canEdit) {
      this.resetUserRealtimeDataAndSlideToBegining();
    } else {
      try {
        await this.setQuizToInProgress();
        if (this.timer) {
          await this.resetUserTimer();
        }
        this.resetUserRealtimeDataAndSlideToBegining();
      } catch (error) {
        console.error('Erreur lors du redémarrage du quiz:', error);
        WElMessage.showErrorMessage(this.$t('errors.default'));
      }
    }
  }
  async onQuizTerminateButtonClick() {
    if (this.canEdit) {
      this.examQuizStep = ExamQuizPlayerStep.TERMINATED;
      // Notify legacy PlanPanel that the quiz has been terminated
      try {
        trig(Events.QUIZZ_COMPLETED);
      } catch (e) {/* noop */}
    } else {
      await axios.put(`${this.BASE_API_QUIZ}/${this.quiz?.id}/validate-exam-quiz-results`, null, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(() => {
        this.examQuizStep = ExamQuizPlayerStep.TERMINATED;
        // Notify legacy PlanPanel that the quiz has been terminated (validated server-side)
        try {
          trig(Events.QUIZZ_COMPLETED);
        } catch (e) {/* noop */}
      }).catch(e => {
        WElMessage.showErrorMessage(this.$t('errors.default'));
      });
    }
  }
  async setQuizToInProgress() {
    await axios.put(`${this.BASE_API_QUIZ}/${this.quiz?.id}/change-exam-quiz-state`, null, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).catch(e => {
      throw new Error(e);
    });
  }
  async resetUserTimer() {
    await axios.put(`${this.BASE_API_QUIZ}/${this.quiz?.id}/reset-exam-quiz-timer`, null, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).catch(e => {
      throw new Error(e);
    });
  }
  resetUserRealtimeDataAndSlideToBegining() {
    this.initExamQuizUserRealtimeData(this.examQuizUserRealtimeData.remaningTries);
    this.examQuizViewerCarousel?.slideTo(0);
    this.examQuizStep = ExamQuizPlayerStep.PREAMBLE;
    this.layoutKey++; //We force the quiz layout du refresh.. (to reset good positionning of timer and footer)
  }
  moveToNextSlide() {
    this.examQuizViewerCarousel?.next();
  }
  lastSlideReached() {
    return this.examQuizUserRealtimeData?.currentSlideIndex >= this.displayableQuestions.length;
  }
  countdownEnd() {
    this.examQuizUserRealtimeData.timeElapsed = true;
    this.updateOverallAnswersWithCurrentQuestionAnswers();
    if (this.isScorm) {
      this.validateScormQuiz();
    } else {
      this.validateQuizAnswers();
    }
  }
  validateQuizAnswers() {
    if (!this.isSavingResults) {
      this.isSavingResults = true;
      if (this.canEdit) {
        this.checkUserAnswersAndDisplayResults();
      } else {
        this.saveUserAnswersAndDisplayResults();
      }
    }
  }
  unmounted() {
    if (this.timer && this.timerComponent.getRemainingSeconds() > 0) {
      this.timerComponent.stopCounting();
    }
  }
};
__decorate([Prop({
  required: true
})], ExamQuizPlayer.prototype, "quizJsonString", void 0);
__decorate([Prop({
  default: ''
})], ExamQuizPlayer.prototype, "quizResultJsonString", void 0);
__decorate([Prop({
  required: true
})], ExamQuizPlayer.prototype, "chapterTitle", void 0);
__decorate([Prop({
  required: true
})], ExamQuizPlayer.prototype, "isScorm", void 0);
__decorate([Prop({
  default: false
})], ExamQuizPlayer.prototype, "canEdit", void 0);
__decorate([Prop({
  default: false
})], ExamQuizPlayer.prototype, "isSpeachTemplate", void 0);
__decorate([Prop({
  default: null
})], ExamQuizPlayer.prototype, "quizResultState", void 0);
__decorate([Prop({
  default: 0
})], ExamQuizPlayer.prototype, "remainingTries", void 0);
__decorate([Prop({
  default: 0
})], ExamQuizPlayer.prototype, "timer", void 0);
__decorate([Prop({
  default: 0
})], ExamQuizPlayer.prototype, "remainingSeconds", void 0);
__decorate([Prop({
  default: false
})], ExamQuizPlayer.prototype, "hideValidationOnUnlimitedRetries", void 0);
__decorate([Ref('examQuizViewerCarousel')], ExamQuizPlayer.prototype, "examQuizViewerCarousel", void 0);
__decorate([Ref('timerComponent')], ExamQuizPlayer.prototype, "timerComponent", void 0);
ExamQuizPlayer = __decorate([Component({
  components: {
    ExamQuiz,
    ExamQuizResults,
    ExamQuizScore,
    ExamQuizQuiz,
    Timer,
    ChapterWideScreenMsg,
    QuizPreamble,
    QuizViewerCarousel,
    QuizViewerLayout,
    InformationDialog,
    SimpleQuiz,
    Pagination,
    Navigation,
    Slide,
    Carousel,
    StandardButton
  }
})], ExamQuizPlayer);
export default ExamQuizPlayer;